// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"600":"87486658","746":"59318bcc"}[chunkId] + ".css";
};